module.exports = "<p>FAQ Coming Soon</p>"


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/additional-pages/faq/faq.component.html
// module id = ../../../../../src/app/components/additional-pages/faq/faq.component.html
// module chunks = main